<div class="cooler_table">
  <div class="cooler_header_section">
    <div style="font-size:  0.98vw; font-weight: 600">Cooler Management</div>
    <div class="data_files">
      <button (click)="openInputForUpload()" >
        <img src="../../assets/upload.png" alt="upload" /> Upload Data File
      </button>
      <input #fileInput type="file" (change)="uploadCsv($event)" accept=".csv" style="display: none;">
      <button (click)="downloadCoolerData('admin_cooler')">
        <img src="../../assets/download.png" alt="download" /> Download Data
        File
      </button>
    </div>
  </div>
  <table
    [formGroup]="dropdown_data_form_group"
    mat-table
    *ngIf="dataSource.data.length > 0"
    #mytable
    [dataSource]="dataSource"
  >
    <ng-container matColumnDef="bottler">
      <th
        style="padding-left: 10px; width: 60px"
        mat-header-cell
        *matHeaderCellDef
      >
        <mat-form-field  *ngIf="bottlerData.length > 0">
          <mat-label> Bottler </mat-label>
          <mat-select
            value="dropdown_data_form_group.controls['bottler'].value"
            formControlName="bottler"
            multiple
          >
            <mat-option (click)="toggleSelection(b,'bottler',0)" *ngFor="let b of bottlerData" [value]="b">{{
              b
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </th>
      <td mat-cell *matCellDef="let data">{{ data.bottler }}</td>
    </ng-container>
    <ng-container matColumnDef="unit">
      <th
        style="padding-left: 10px; width: 60px"
        mat-header-cell
        *matHeaderCellDef
      >
        <mat-form-field *ngIf="unitData.length > 0">
          <mat-label>Unit</mat-label>
          <mat-select
            formControlName="unit"
            multiple
            value="dropdown_data_form_group.controls['unit'].value"
          >
            <mat-option (click)="toggleSelection(b,'unit',1)" *ngFor="let b of unitData" [value]="b">{{
              b
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </th>
      <td mat-cell *matCellDef="let data">{{ data.unit }}</td>
    </ng-container>
    <ng-container matColumnDef="channel">
      <th
        style="padding-left: 10px; width: 60px"
        mat-header-cell
        *matHeaderCellDef
      >
        <mat-form-field *ngIf="channelData.length > 0">
          <mat-label>Channel</mat-label>
          <mat-select
            formControlName="channel"
            value="dropdown_data_form_group.controls['channel'].value"
            multiple
          >
            <mat-option
              class="channel_option"
              (click)="toggleSelection(c,'channel',2)"
              *ngFor="let c of channelData"
              [value]="c"
              >{{ c }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </th>
      <td mat-cell *matCellDef="let data">{{ data.channel }}</td>
    </ng-container>
    <ng-container matColumnDef="caser">
      <th
        style="padding-left: 10px; width: 60px"
        mat-header-cell
        *matHeaderCellDef
      >
        <mat-form-field *ngIf="coolerData.length > 0">
          <mat-label>Cooler</mat-label>
          <mat-select
            formControlName="cooler"
            multiple
            value="dropdown_data_form_group.controls['cooler'].value"
          >
            <mat-option  (click)="toggleSelection(c,'cooler',3)" *ngFor="let c of coolerData" [value]="c">{{
              c
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </th>
      <td mat-cell *matCellDef="let data">{{ data.caser }}</td>
    </ng-container>
    <ng-container matColumnDef="cooler_image_uri">
      <th style="padding-left: 10px" mat-header-cell *matHeaderCellDef>
        Cooler image
      </th>
      <td mat-cell *matCellDef="let data">
        <img style="height:120px;width:45px;" alt="image" [src]="data.cooler_image_uri
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        " />
      </td>
    </ng-container>
    <ng-container matColumnDef="internal_dimensions">
      <th style="padding-left: 10px" mat-header-cell *matHeaderCellDef>
        Dimensions
      </th>
      <td mat-cell *matCellDef="let data">
        <div>
          <div>Height:{{ data.height }}</div>
          <div>Width:{{ data.width }}</div>
          <div>Depth:{{ data.depth }}</div>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="shelf_1">
      <th style="padding-left: 10px" mat-header-cell *matHeaderCellDef>
        Shelves
      </th>
      <td mat-cell *matCellDef="let data">
        <div *ngIf="data" style="white-space: pre-line">
          {{
            calculateTotalShelves(
              data.shelf_1,
              data.shelf_2,
              data.shelf_3,
              data.shelf_4,
              data.shelf_5,
              data.shelf_6
            )
          }}
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="ss_facings">
      <th style="padding-left: 10px" mat-header-cell *matHeaderCellDef>
        Facings
      </th>
      <td mat-cell *matCellDef="let data">
        <div>
          <div>
            Total:{{
              data.ss_facings +
                data.otg_facings +
                data.hpet_facings +
                data.lpet_facings
            }}
          </div>
          <div>SS:{{ data.ss_facings }}</div>
          <div>OTG:{{ data.otg_facings }}</div>
          <div>HPET:{{ data.hpet_facings }}</div>
          <div>LPET:{{ data.lpet_facings }}</div>
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: columns"></tr>
  </table>
  <mat-paginator
    *ngIf="admin_cooler_data && admin_cooler_data.length>0"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    hidePageSize="true"
    [length]="filtered_admin_cooler_data.length"
    (page)="paginationChange($event)"
    class="admin-cooler-paginator"
  >
  </mat-paginator>
  <app-loader
    [is_show_loader]="(loader | async)! || is_show_loader"
  ></app-loader>
 
</div>
